import React from 'react';

import { useRequiredParams } from 'utils';
import { AccountNavCash } from 'views/account/AccountNavCash';
import { AccountOverview } from 'views/account/AccountOverview';
import { useAccount } from 'views/portfolio/account-queries';

export const AccountOverviewTab = () => {
    const { accountGUID } = useRequiredParams(['accountGUID']);
    const { data: account } = useAccount(accountGUID);

    return !account ? (
        'Loading... '
    ) : (
        <div className="space-y-4">
            <AccountNavCash accountGUID={accountGUID} className="pt-4 pl-4" />
            <AccountOverview account={account} />
        </div>
    );
};
